/**
 * NA-391: client mirror of the Question Bank purpose rules, used only to show
 * the purpose live in the create/edit dialog as the author changes Gated or
 * the healthy response. The server derives and stores the real value on save
 * (author-api/src/services/questionPurpose.ts — keep the two in step; the
 * repos cannot share a package). Authors never set purpose, except on
 * Freeform Text, which offers exactly Sentiment or Reflection.
 */
export type QuestionPurpose = 'Knowledge' | 'Sentiment' | 'Survey' | 'Reflection';

/** The only values an author may pick, and only for Freeform Text. */
export const FREEFORM_PURPOSE_CHOICES: readonly QuestionPurpose[] = ['Sentiment', 'Reflection'];

export interface QuestionPurposeInput {
  blockType: 'likert-scale' | 'single-choice-answer' | 'workplace-color-spectrum' | 'categorization' | 'freeform-text';
  /** Single Choice only. */
  gated?: boolean;
  /** Likert only: any healthy response (left or right) is set. */
  hasHealthyResponse?: boolean;
  /** Freeform Text only: the author's choice. */
  requestedPurpose?: QuestionPurpose | null;
}

export function deriveQuestionPurpose(input: QuestionPurposeInput): QuestionPurpose {
  switch (input.blockType) {
    case 'likert-scale':
      return input.hasHealthyResponse ? 'Sentiment' : 'Reflection';
    case 'single-choice-answer':
      return input.gated ? 'Knowledge' : 'Reflection';
    case 'workplace-color-spectrum':
    case 'categorization':
      return 'Knowledge';
    case 'freeform-text':
      return input.requestedPurpose === 'Reflection' ? 'Reflection' : 'Sentiment';
  }
}
